import { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText, Loader2, ImageIcon } from 'lucide-react';
import { toast } from 'sonner';
import { PanelImage } from '../lib/panelImages';

const API = process.env.REACT_APP_BACKEND_URL;
const fmtDate = (iso) => new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

export function EnvoisAffichesPanel({ userEmail }) {
  const email = (userEmail || '').toLowerCase();
  const [envois, setEnvois] = useState([]);
  const [opening, setOpening] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/technique/envois-affiches`).then((r) => setEnvois(r.data || [])).catch(() => setEnvois([]));
  }, []);

  const openPdf = async (e) => {
    setOpening(e.id);
    try {
      const r = await axios.get(`${API}/api/technique/envois-affiches/${e.id}/pdf`, { responseType: 'blob' });
      window.open(URL.createObjectURL(r.data), '_blank');
      setEnvois((list) => list.map((x) => (x.id === e.id ? { ...x, vu_par: [...(x.vu_par || []), email] } : x)));
    } catch {
      toast.error("Impossible d'ouvrir le PDF");
    } finally { setOpening(null); }
  };

  if (!envois.length) return null;
  return (
    <div className="bg-white rounded-2xl border border-orange-200 shadow-sm p-4" data-testid="envois-affiches-panel">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center"><ImageIcon className="h-4 w-4" /></div>
        <div>
          <h2 className="text-sm font-bold text-slate-900">Images reçues de la conception</h2>
          <p className="text-xs text-slate-500">Affiches et vidéos à imprimer ou diffuser</p>
        </div>
      </div>
      <div className="space-y-2 max-h-72 overflow-y-auto pr-1">
        {envois.map((e) => {
          const isNew = !(e.vu_par || []).includes(email);
          return (
            <div key={e.id} className="flex items-center gap-3 p-2 rounded-xl hover:bg-slate-50 transition-colors" data-testid={`envoi-affiche-${e.id}`}>
              <div className="w-11 h-11 rounded-lg bg-slate-50 overflow-hidden flex-shrink-0"><PanelImage type={e.panneau_type} className="h-full w-full" /></div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-slate-900 truncate">
                  Panneau #{e.panneau_numero || '—'} · {e.panneau_type}
                  {isNew && <span className="ml-2 text-[10px] font-bold uppercase bg-orange-500 text-white px-1.5 py-0.5 rounded">Nouveau</span>}
                </div>
                <div className="text-xs text-slate-500 truncate">{e.emplacement_nom || '—'} · {e.nb_medias} {e.media_type === 'video' ? 'vidéo(s)' : 'image(s)'} · {fmtDate(e.created_at)} · par {e.sent_by}</div>
              </div>
              <button onClick={() => openPdf(e)} disabled={opening === e.id}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-orange-500 text-white hover:bg-orange-600 transition-colors disabled:opacity-60"
                data-testid={`envoi-affiche-pdf-${e.id}`}>
                {opening === e.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileText className="h-3.5 w-3.5" />} Voir le PDF
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
